import { CognitoUserPool } from 'amazon-cognito-identity-js';
import fetch from 'isomorphic-fetch';

import config from '../config';

export async function unauthInvokeApig({
  service,
  path,
  method = 'GET',
  body,
}) {
  const url = `https://${config.SERVICES.V2}/${config.ENV}${path}`;
  // NOTE: Uncomment for localhost connection
  // const url = `http://localhost:3000/serverless-local`
  // const url = `http://localhost:3000/serverless-local-qa`
  // const url = `http://localhost:3000/serverless-local-stage`
  // const url = `http://localhost:3000/serverless-local-demo`
  // const url = `http://localhost:3000/serverless-local-prod`
  const headers = {};

  if (method === 'POST') {
    headers['content-type'] = 'application/json';
  }
  body = body ? JSON.stringify(body) : body;
  const results = await fetch(url, {
    method,
    body,
    headers,
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }
  return results.json();
}

export async function invokeApig(
  { service, path, method = 'GET', retry, body },
  userToken
) {
  let accessToken = '';
  const currentUser = getCurrentUser();
  if (currentUser === null) {
    return;
  }

  try {
    accessToken = await getUserToken(currentUser);
  } catch (e) {
    console.warn(e);
  }

  let cacheBusterPath = path;
  if (isIE()) {
    if (method === 'GET') {
      if (cacheBusterPath.indexOf('?') > 0) {
        cacheBusterPath += `&rand=${new Date().getTime()}`;
      } else {
        cacheBusterPath += `?rand=${new Date().getTime()}`;
      }
    }
  }

  if (accessToken !== '') {
    const url = `https://${config.SERVICES.V2}/${config.ENV}${cacheBusterPath}`;
    // NOTE: Uncomment for localhost connection
    // const url = `http://localhost:3000/serverless-local${ cacheBusterPath }`
    // const url = `http://localhost:3000/serverless-local-qa${ cacheBusterPath }`
    // const url = `http://localhost:3000/serverless-local-stage${ cacheBusterPath }`
    // const url = `http://localhost:3000/serverless-local-demo${ cacheBusterPath }`
    // const url = `http://localhost:3000/serverless-local-prod${ cacheBusterPath }`
    const headers = {
      Authorization: accessToken,
      Accept: 'application/json',
      'content-type': 'application/json',
    };
    body = body ? JSON.stringify(body) : body;

    try {
      return await fetcher(url, { method, body, headers });
    } catch (ex) {
      if (!ex.message.toLowerCase().includes('timeout') && !retry) {
        throw ex;
      }

      try {
        return await fetcher(url, { method, body, headers });
      } catch (ex2) {
        if (!ex2.message.toLowerCase().includes('timeout') && !retry) {
          throw ex2;
        }

        return await fetcher(url, { method, body, headers });
      }
    }
  }
}

async function fetcher(url, { method, body, headers }) {
  const results = await fetch(url, {
    method,
    body,
    headers,
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }
  return results.json();
}

export async function authUser() {
  const currentUser = getCurrentUser();

  if (currentUser === null) {
    return false;
  }

  await getUserToken(currentUser);

  return true;
}

export function signOutUser() {
  const currentUser = getCurrentUser();

  if (currentUser !== null) {
    currentUser.signOut();
  }
}

function getUserToken(currentUser) {
  return new Promise((resolve, reject) => {
    currentUser.getSession(function (err, session) {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

export function getCurrentUser() {
  const cognitoUserPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID,
  });
  const cognitoUser = cognitoUserPool.getCurrentUser();
  if (cognitoUser) {
    return cognitoUser;
  }
  const ssoUserPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.SSO_APP_CLIENT_ID,
  });
  const ssoUser = ssoUserPool.getCurrentUser();
  return ssoUser;
}

function isIE() {
  const ua = window.navigator.userAgent;
  const trident = ua.indexOf('Trident/');
  return trident > 0;
}
